import React from "react";
import { Link } from "react-router-dom";
import { BsLinkedin, BsGithub, BsYoutube, BsInstagram } from "react-icons/bs";
import newsletter from "../images/newsletter.png";
const Footer = () => {
  return (
    <>
      <footer className="py-4">
        <div className="container-xxl">
          <div className="row align-items-center">
            <div className="col-5">
              <div className="footer-top-data d-flex gap-30 align-items-center">
                <img src={newsletter} alt="newsletter" />
                <h2 className="mb-0 text-white">الاشتراك في النشرة الإخبارية</h2>
              </div>
            </div>
            <div className="col-7">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control py-1"
                  placeholder="عنوان بريدك  الإلكتروني"
                  aria-label="عنوان بريدك  الإلكتروني"
                  aria-describedby="basic-addon2"
                />
                <span className="input-group-text p-2" id="basic-addon2">
                  أشترك الأن
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className="py-4">
        <div className="container-xxl">
          <div className="row">
            <div className="col-4">
              <h4 className="text-white mb-4">تواصل معنا</h4>
              <div>
                <address className="text-white fs-6">
                  عنوان : 247 6 October, <br /> Giza, Egypt <br />
                  الرمز البريدي: 131103
                </address>
                <a
                  href="tel:+91 8264954234"
                  className="mt-3 d-block mb-1 text-white"
                >
                  +91 8264954234
                </a>
                <a
                  href="mailto:info.mohamedhussein@gmail.com"
                  className="mt-2 d-block mb-0 text-white"
                >
                info.mohamedhussein@gmail.com
                </a>
                <div className="social_icons d-flex align-items-center gap-30 mt-4">
                  <a className="text-white" href="#">
                    <BsLinkedin className="fs-4" />
                  </a>
                  <a className="text-white" href="#">
                    <BsInstagram className="fs-4" />
                  </a>
                  <a className="text-white" href="#">
                    <BsGithub className="fs-4" />
                  </a>
                  <a className="text-white" href="#">
                    <BsYoutube className="fs-4" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-3">
              <h4 className="text-white mb-4">معلومات</h4>
              <div className="footer-link d-flex flex-column">
                <Link to="/privacy-policy" className="text-white py-2 mb-1">
                سياسة الخصوصية
                </Link>
                <Link to="/refund-policy" className="text-white py-2 mb-1">
                سياسة الاسترجاع
                </Link>
                <Link to="/shipping-policy" className="text-white py-2 mb-1">
                سياسة الشحن
                </Link>
                <Link to="/term-conditions" className="text-white py-2 mb-1">
                البنود و الظروف
                </Link>
                <Link className="text-white py-2 mb-1">المدونة</Link>
              </div>
            </div>
            <div className="col-3">
              <h4 className="text-white mb-4">صفحات مهمة</h4>
              <div className="footer-link d-flex flex-column">
                <Link className="text-white py-2 mb-1">معلومات عنا</Link>
                <Link className="text-white py-2 mb-1">التعليمات</Link>
                <Link className="text-white py-2 mb-1">تواصل معنا</Link>
              </div>
            </div>
            <div className="col-2">
              <h4 className="text-white mb-4">روابط سريعة</h4>
              <div className="footer-link d-flex flex-column">
                <Link className="text-white py-2 mb-1">أجهزة الكمبيوتر المحمولة</Link>
                <Link className="text-white py-2 mb-1">سماعات الرأس</Link>
                <Link className="text-white py-2 mb-1">أجهزة لوحية</Link>
                <Link className="text-white py-2 mb-1">ساعات</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className="py-4">
        <div className="container-xxl">
          <div className="row">
            <div className="col-12">
              <p className="text-center mb-0 text-white">
              جميع الحقوق محفوظة لدي ريفينو © 2023 | تم الإنشاء بواسطة محمد حسين
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
